/* ALBEUX (3 Nov 2026): BACK FROM A PRODUCT PAGE - NO LIFT, NO BLINK.
   When Back is pressed the slide-out puts the page underneath at its scroll position. The browser then sometimes moves the page again a split second later
   (the log showed 0 -> 97 -> 0 px within about 0.07s), and on the phone that shows as a small lift and a blink.
   This file only watches: for the next second after Back it puts the page back at the position the slide-out chose, and only if the page moved without the customer touching it.
   It changes nothing else and touches none of the other scripts. To undo: delete the albeux-back-steady line in snippets/view-transition-opt-in.liquid. */
(function () {
  'use strict';
  if (window.__albBackSteady) return;
  window.__albBackSteady = true;
  var until = 0, target = 0, fixing = false, touched = false;
  function y() { return window.pageYOffset || window.scrollY || 0; }
  function stop() { until = 0; }
  ['touchstart', 'wheel', 'keydown', 'mousedown'].forEach(function (n) {
    window.addEventListener(n, function () { if (until) touched = true; }, { passive: true, capture: true });
  });
  /* registered after the slide scripts, so it runs after their own Back handling has put the page where it belongs */
  window.addEventListener('popstate', function () {
    try {
      var d = document.documentElement;
      if (!d || !d.classList.contains('alb-hold')) return;
      touched = false;
      target = y();
      until = Date.now() + 1000;
    } catch (e) {}
  });
  window.addEventListener('scroll', function () {
    try {
      if (!until || fixing) return;
      if (Date.now() > until || touched) { stop(); return; }
      if (Math.abs(y() - target) < 1) return;
      fixing = true;
      var h = document.documentElement, prev = h.style.scrollBehavior;
      h.style.scrollBehavior = 'auto';
      window.scrollTo(0, target);
      h.style.scrollBehavior = prev;
      fixing = false;
    } catch (e) { fixing = false; }
  }, true);
})();